// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"293":"component---src-pages-index-js","563":"cb355538"}[chunkId] || chunkId) + "-" + {"293":"179d54ecfcbc55fd0344","454":"593b8b006ecfa508b580","563":"dae2585aedae9175f04a"}[chunkId] + ".js";
};